import src from "IMAGE";
export default { src, width: 2048, height: 2048, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAOUlEQVR42n1OQQ4AIAjipcT/X1Ed2kicB6agiACwDlSqAxyGV/vI62k8XBGh5oprbUT8oGlBBhaDNiNeF9IDxqlOAAAAAElFTkSuQmCC"};
